import { render, staticRenderFns } from "./levelPrivilege.vue?vue&type=template&id=53e5f9fe&scoped=true"
import script from "./levelPrivilege.vue?vue&type=script&lang=js"
export * from "./levelPrivilege.vue?vue&type=script&lang=js"
import style0 from "./levelPrivilege.vue?vue&type=style&index=0&id=53e5f9fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e5f9fe",
  null
  
)

export default component.exports